import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { SobDemandaFormControlComponent } from './sob-demanda-form-control-radio.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        SobDemandaFormControlComponent
    ],
    exports: [
        SobDemandaFormControlComponent
    ]
})
export class SobDemandaFormControlModule { }
